import { buryPoint } from '@/Common/plugins/buried-point';

export default {
  costCenter (where) {
    const op = {
      1: 'Home页-顶部￥按钮下拉菜单',
      2: '左侧导航',
      3: '远程运维购买成功页-查看订单记录',
      4: '员工数购买成功页-查看订单记录',
      5: '员工账号数购买成功(您的员工人数大约已购账号数)页-推荐操作'
    };
    buryPoint.event({
      action: '查看费用中心-入口位置',
      eventCategory: '查看费用中心',
      eventLabel: op[where]
    });
  },
  onlinePayOrderByData () {
    buryPoint.event({
      action: '订单时间筛选-使用功能',
      eventCategory: '订单时间筛选'
    });
  },
  orderDetail() {
    buryPoint.event({
      action: '查看订单详情-查看信息',
      eventCategory: '查看订单详情'
    });
  },
  unpaidOrderPay() {
    buryPoint.event({
      action: '未支付订单支付-使用功能',
      eventCategory: '未支付订单支付'
    });
  },
  onlinePayOrder() {
    buryPoint.event({
      action: '查看在线支付订单-查看信息',
      eventCategory: '查看在线支付订单'
    });
  },
  licenseOrder() {
    buryPoint.event({
      action: '查看服务激活码记录-查看信息',
      eventCategory: '查看服务激活码记录'
    });
  },
  packageManager(flag) {
    const op = {
      1: '左侧导航面板',
      2: 'Home页-顶部￥按钮下拉菜单',
      3: '远程运维购买成功页-推荐操作',
      4: '员工数购买成功页-推荐操作',
      5: '首页-banner(增值服务免费试用)'
    };
    buryPoint.event({
      action: '查看Package管理-入口位置',
      eventCategory: '查看Package管理',
      eventLabel: op[flag]
    });
  },
  newViewPackageDetail(flag) {
    const op = {
      1: '我的服务顶部tab',
      2: '我的服务-全部服务-查看使用详情',
      3: '我的服务-全部服务-30天内到期统计',
      4: '运维服务激活结果页-立即查看'
    };
    buryPoint.event({
      action: '查看我的服务-健康监测包tab',
      eventCategory: '查看我的服务',
      eventLabel: op[flag]
    });
  },
  viewPackageDetail(flag) {
    const op = {
      1: 'basic package卡片',
      2: '已购买的远程运维package卡',
      3: '服务市场package卡片',
      4: '远程运维package购买页',
      5: '公司信息页'
    };
    buryPoint.event({
      action: '查看Package详情-入口位置',
      eventCategory: '查看Package详情',
      eventLabel: op[flag]
    });
  },
  viewHCCDetail(flag) {
    const op = {
      1: '我的服务 顶部tab',
      2: '我的服务-全部服务-查看详情'
    };
    buryPoint.event({
      action: '查看我的服务-Hik-Connect Commercial tab',
      eventCategory: '查看我的服务',
      eventLabel: op[flag]
    });
  },
  viewCloudAttendance(flag) {
    const op = {
      1: '我的服务 顶部tab',
      2: '我的服务-全部服务-查看详情'
    };
    buryPoint.event({
      action: '查看我的服务-云考勤服务tab',
      eventCategory: '查看云考勤服务详细',
      eventLabel: op[flag]
    });
  },
  checkoutOrderClick(flag) {
    const op = {
      1: '在线购买运维package',
      2: '运维package续费',
      3: '运维package扩容'
    };
    buryPoint.event({
      action: `${op[flag] }-使用功能`,
      eventCategory: op[flag]
    });
  },
  checkoutEmployeeOrderClick(flag) {
    const op = {
      1: '在线购买员工账号数',
      2: '员工账号数续费',
      3: '员工账号数扩容'
    };
    buryPoint.event({
      action: `${op[flag] }-使用功能`,
      eventCategory: op[flag]
    });
  },
  maintenanceEntrance(flag) {
    const op = {
      1: 'package详情页-在线购买',
      2: '服务市场package卡片-在线购买',
      3: '付款失败页-重新购买',
      4: '定时发送报表空白页-立即购买',
      5: '设备健康状态空白页-立即购买',
      6: '异常中心空白页-立即购买',
      7: '激活运维服务页-在线购买',
      8: '健康监测包余量页-在线购买',
      9: '健康监测包详情页-在线购买',
      10: '批量延长使用页-在线购买',
      11: 'myPackage健康监测包卡片-在线购买'
    };
    buryPoint.event({
      action: '在线购买运维package-入口位置',
      eventCategory: '在线购买运维package',
      eventLabel: op[flag]
    });
  },
  paymentResult(flag, which) {
    const type = {
      1: '在线购买运维package',
      2: '运维package续费',
      3: '运维package扩容'
    };
    const op = {
      1: '购买成功',
      2: '付款失败'
    };
    buryPoint.event({
      action: `${type[which] }-购买结果`,
      eventCategory: type[which],
      eventLabel: op[flag]
    });
  },
  maintenancePage(flag) {
    const op = {
      1: '在线购买运维package',
      2: '运维package续费',
      3: '运维package扩容'
    };
    buryPoint.event({
      action: `${op[flag] }-进入购买页`,
      eventCategory: op[flag]
    });
  },
  employeePage(flag) {
    const op = {
      1: '在线购买员工账号数',
      2: '员工账号数续费',
      3: '员工账号数扩容'
    };
    buryPoint.event({
      action: `${op[flag] }-进入购买页`,
      eventCategory: op[flag]
    });
  },
  maintenanceRepay(flag) {
    const op = {
      1: '在线购买运维package',
      2: '运维package续费',
      3: '运维package扩容'
    };
    buryPoint.event({
      action: `${op[flag] }-重新支付`,
      eventCategory: op[flag]
    });
  },
  packageExtendEntrance(flag) {
    const op = {
      1: '已购买的运程运维卡片-扩容',
      2: '服务市场package卡片-扩容',
      3: '付款失败页-重新购买',
      4: '运维管理页-扩容'
    };
    buryPoint.event({
      action: '运维package扩容-入口位置',
      eventCategory: '运维package扩容',
      eventLabel: op[flag]
    });
  },
  packageRenewEntrance(flag) {
    const op = {
      1: '已购买的运程运维卡片-续费',
      2: '服务市场package卡片-续费',
      3: '付款失败页-重新购买',
      4: '站点详情页-异常通知tab-立即购买'
    };
    buryPoint.event({
      action: '运维package续费-入口位置',
      eventCategory: '运维package续费',
      eventLabel: op[flag]
    });
  },
  buyMaintenanceBylicense() {
    buryPoint.event({
      action: '服务激活码购买运维Package-使用功能',
      eventCategory: '服务激活码购买运维Package'
    });
  },
  buyMaintenanceBylicenseEntrance(flag) {
    const op = {
      1: 'package详情页-服务激活码购买',
      2: '服务市场package卡片-服务激活码购买',
      3: '已购买的远程运维卡片-服务激活码购买',
      4: '运维服务激活-服务激活码购买',
      5: '健康监测包余量页-服务激活码购买',
      6: '健康监测包详情页-服务激活码购买',
      7: 'myPackage健康监测包卡片-服务激活码购买'
    };
    buryPoint.event({
      action: '服务激活码购买运维Package-入口位置',
      eventCategory: '服务激活码购买运维Package',
      eventLabel: op[flag]
    });
  },
  buyMaintenanceBylicenseResult(flag) {
    const op = {
      1: '激活成功',
      2: ' 服务激活码无效'
    };
    buryPoint.event({
      action: '服务激活码购买运维Package-激活结果',
      eventCategory: '服务激活码购买运维Package',
      eventLabel: op[flag]
    });
  },
  buyEmployeeBylicenseResult(flag) {
    const op = {
      1: '激活成功',
      2: ' 服务激活码无效'
    };
    buryPoint.event({
      action: '服务激活码购买员工账号数-激活结果',
      eventCategory: '服务激活码购买员工账号数',
      eventLabel: op[flag]
    });
  },
  buyEmployeeBylicense() {
    buryPoint.event({
      action: '服务激活码购买员工账号数-使用功能',
      eventCategory: '服务激活码购买员工账号数'
    });
  },
  buyEmployeeBylicenseEntrance(flag) {
    const op = {
      1: '已购买的员工账号数卡片-服务激活码购买',
      2: '服务市场package卡片-服务激活码购买',
      3: '启用账号数达上限，启用失败',
      4: '启用账号数达上限，添加失败'
    };
    buryPoint.event({
      action: '服务激活码购买员工账号数-入口位置',
      eventCategory: '服务激活码购买员工账号数',
      eventLabel: op[flag]
    });
  },
  employeeExtendEntrance(flag) {
    const op = {
      1: '已购买的员工账号数卡片-扩容',
      2: '服务市场package卡片-扩容',
      3: '付款失败页-重新购买',
      4: '启用账号数达上限，启用失败',
      5: '启用账号数达上限，添加失败'
    };
    buryPoint.event({
      action: '员工账号数扩容-入口位置',
      eventCategory: '员工账号数扩容',
      eventLabel: op[flag]
    });
  },
  employeeRenewEntrance(flag) {
    const op = {
      1: '已购买的员工账号数卡片-续费',
      2: '服务市场package卡片-续费',
      3: '付款失败页-重新购买'
    };
    buryPoint.event({
      action: '员工账号数续费-入口位置',
      eventCategory: '员工账号数续费',
      eventLabel: op[flag]
    });
  },
  onlineEmployeeEntrance(flag) {
    const op = {
      1: '服务市场package卡片-在线购买',
      2: '付款失败页-重新购买'
    };
    buryPoint.event({
      action: '在线购买员工账号数-入口位置',
      eventCategory: '在线购买员工账号数',
      eventLabel: op[flag]
    });
  },
  employeePaymentResult(flag, which) {
    const type = {
      1: '在线购买员工账号数',
      2: '员工账号数续费',
      3: '员工账号数扩容'
    };
    const op = {
      1: '购买成功',
      2: '购买成功，您的员工人数大约已购账号数',
      3: '付款失败'
    };
    buryPoint.event({
      action: `${type[which] }-购买结果`,
      eventCategory: type[which],
      eventLabel: op[flag]
    });
  },
  employeRepay(flag) {
    const op = {
      1: '在线购买员工账号数',
      2: '员工账号数续费',
      3: '员工账号数扩容'
    };
    buryPoint.event({
      action: `${op[flag] }-重新支付`,
      eventCategory: op[flag]
    });
  },
  checkoutCloudServiceClick() {
    buryPoint.event({
      action: '购买云存储服务-使用功能',
      eventCategory: '购买云存储服务'
    });
  },
  cloudStoragePage() {
    buryPoint.event({
      action: '购买云存储服务-进入购买页',
      eventCategory: '购买云存储服务'
    });
  },
  cloudStorageEntrance(flag) {
    const op = {
      1: '服务市场',
      2: '我的服务',
      3: '付款失败页-重新购买',
      4: '延长服务弹窗-前往购买',
      5: '增值服务到期提醒弹窗'
    };
    buryPoint.event({
      action: '购买云存储服务-入口位置',
      eventCategory: '购买云存储服务',
      eventLabel: op[flag]
    });
  },
  cloudStorageRepay() {
    buryPoint.event({
      action: '购买云存储服务-重新支付',
      eventCategory: '购买云存储服务'
    });
  },
  cloudStoragePaymentResult(flag) {
    const op = {
      1: '购买成功',
      2: '付款失败'
    };
    buryPoint.event({
      action: '购买云存储服务-购买结果',
      eventCategory: '购买云存储服务',
      eventLabel: op[flag]
    });
  },
  priceButtonClick(flag, isAuth) {
    const op = {
      1: 'Health Monitoring Package',
      2: 'Employee Account Add-on',
      3: 'Cloud Storage'
    };
    const isAuthTxt = isAuth ? '已认证' : '未认证';
    buryPoint.event({
      action: '查看价格单-查看信息',
      eventCategory: '查看价格单',
      eventLabel: `${op[flag] }-${ isAuthTxt}`
    });
  },
  priceButtonExposure() {
    buryPoint.event({
      action: '查看价格单-曝光量',
      eventCategory: '查看价格单'
    });
  },
  viewPackageTabAll() {
    buryPoint.event({
      action: '查看Package管理-全部服务tab',
      eventCategory: '查看Package管理'
    });
  },
  viewPackageTabCloudStorage() {
    buryPoint.event({
      action: '查看Package管理-云存储服务详情tab',
      eventCategory: '查看Package管理'
    });
  },
  viewServiceMarket(flag) {
    const op = {
      1: '开通支付',
      2: '未开通支付'
    };
    buryPoint.event({
      action: '查看服务市场-查看信息',
      eventCategory: '查看服务市场',
      eventLabel: op[flag]
    });
  },
  select30DaysLimit() {
    buryPoint.event({
      action: '运维包到期-30天内即将到期',
      eventCategory: '运维包到期'
    });
  },
  selectExpiredDevices() {
    buryPoint.event({
      action: '运维包到期-已过期的设备',
      eventCategory: '运维包到期'
    });
  },
  enterExtendedUse() {
    buryPoint.event({
      action: '健康监测包延长使用-进入弹窗',
      eventCategory: '健康监测包延长使用'
    });
  },
  submitExtendedUse() {
    buryPoint.event({
      action: '健康监测包延长使用-提交',
      eventCategory: '健康监测包延长使用'
    });
  },
  enterHealthMonitoringPackageTransfer() {
    buryPoint.event({
      action: '健康监测包转移-进入弹窗',
      eventCategory: '健康监测包转移'
    });
  },
  submitHealthMonitoringPackageTransfer() {
    buryPoint.event({
      action: '健康监测包转移-提交',
      eventCategory: '健康监测包转移'
    });
  },
  automaticRenewalOfHealthMonitoringPackage(flag) {
    const op = {
      0: '关闭',
      1: '开启'
    };
    buryPoint.event({
      action: `健康监测包自动续费-${ op[flag]}`,
      eventCategory: '健康监测包自动续费'
    });
  },
  watchSalesInfo() {
    buryPoint.event({
      action: '查看服务市场-浏览打折活动',
      eventCategory: '查看服务市场'
    });
  },
  onlinePurchaseCloudAttendancePage() {
    buryPoint.event({
      action: '在线购买云考勤-进入购买页',
      eventCategory: '在线购买云考勤'
    });
  },
  onlinePurchaseCloudAttendanceOrder() {
    buryPoint.event({
      action: '在线购买云考勤-提交订单',
      eventCategory: '在线购买云考勤'
    });
  },
  buyCloudAttendanceLicenseEntrance() {
    buryPoint.event({
      action: '卡密激活云考勤服务-出现弹窗',
      eventCategory: '卡密激活云考勤服务	'
    });
  },
  confirmCloudAttendanceLicenseActivation() {
    buryPoint.event({
      action: '卡密激活云考勤服务-确认激活',
      eventCategory: '卡密激活云考勤服务	'
    });
  },
  CloudAttendanceLicenseSuccessVerification() {
    buryPoint.event({
      action: '卡密激活云考勤服务-服务码验证成功',
      eventCategory: '卡密激活云考勤服务	'
    });
  },
  confirmCloudAttendanceLicenseWarehousing() {
    buryPoint.event({
      action: '卡密激活云考勤服务-确认入库',
      eventCategory: '卡密激活云考勤服务	'
    });
  }
};
